import { Link } from 'react-router-dom';
import { categories } from '@/mocks/common';

export default function CategorySection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            赛事分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">覆盖全球主流体育赛事，随心选择</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-2xl text-primary-500`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">
                {cat.matchCount}场赛事
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}